import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Developers from './pages/Developers';
import DeveloperProfile from './pages/DeveloperProfile';
import Teams from './pages/Teams';
import Login from './pages/Login';
import Signup from './pages/Signup';
import PostJob from './pages/PostJob';
import Jobs from './pages/Jobs';
import JobDetail from './pages/JobDetail';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import DeveloperLogin from './pages/developer/DeveloperLogin';
import DeveloperDashboard from './pages/developer/DeveloperDashboard';
import Pricing from './pages/Pricing';
export function AppRouter() {
  return <Routes data-id="element-4">
      <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
      <Route path="/developers" element={<Developers data-id="element-8" />} data-id="element-7" />
      <Route path="/developers/:id" element={<DeveloperProfile data-id="element-10" />} data-id="element-9" />
      <Route path="/teams" element={<Teams data-id="element-12" />} data-id="element-11" />
      <Route path="/login" element={<Login data-id="element-14" />} data-id="element-13" />
      <Route path="/signup" element={<Signup data-id="element-16" />} data-id="element-15" />
      <Route path="/post-job" element={<PostJob data-id="element-18" />} data-id="element-17" />
      <Route path="/jobs" element={<Jobs data-id="element-20" />} data-id="element-19" />
      <Route path="/jobs/:id" element={<JobDetail data-id="element-22" />} data-id="element-21" />
      <Route path="/pricing" element={<Pricing data-id="element-24" />} data-id="element-23" />
      <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-26" />} data-id="element-25" />
      <Route path="/terms-of-service" element={<TermsOfService data-id="element-28" />} data-id="element-27" />
      <Route path="/admin/login" element={<AdminLogin data-id="element-30" />} data-id="element-29" />
      <Route path="/admin/dashboard" element={<AdminDashboard data-id="element-32" />} data-id="element-31" />
      <Route path="/developer/login" element={<DeveloperLogin data-id="element-34" />} data-id="element-33" />
      <Route path="/developer/dashboard" element={<DeveloperDashboard data-id="element-36" />} data-id="element-35" />
    </Routes>;
}